import { render } from "./button.vue?vue&type=template&id=f6d13490"
const script = {}

import "./button.vue?vue&type=style&index=0&id=f6d13490&lang=scss"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__